import { render, staticRenderFns } from "./CompositesHistoryDialog.vue?vue&type=template&id=6fd73000&"
import script from "./CompositesHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./CompositesHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports